import React from 'react';
import Icon from '@mdi/react';
import { mdiCellphone, mdiWeb, mdiClose } from '@mdi/js';
import useEscapeKey from '../hooks/useEscapeKey';
import './BookingOptionModal.css';

/**
 * Modal offering choice between opening mobile app or continuing on web.
 * Used by both booking flow (InstructorPublicProfile) and ticket purchase flow (TicketPurchase).
 *
 * Deep link logic only fires if user explicitly chooses "Open in App".
 */
const BookingOptionModal = ({
  isOpen,
  onClose,
  onOpenApp,
  onContinueWeb,
  heading = 'How would you like to book?',
  appLabel = 'Open in Dance Localé App',
  appSub = 'Faster rebooking & booking history',
  webLabel = 'Book on Website',
  webSub = 'No download needed',
}) => {
  // Close on Escape (stack-aware shared hook)
  useEscapeKey(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div className="booking-option-overlay" onClick={onClose}>
      <div className="booking-option-modal" onClick={(e) => e.stopPropagation()}>
        {/* Purple Header */}
        <div className="booking-option-header">
          <h2>{heading}</h2>
          <button className="booking-option-close" onClick={onClose} aria-label="Close">
            <Icon path={mdiClose} size={1} />
          </button>
        </div>

        {/* Body */}
        <div className="booking-option-body">
          {/* Option 1: Open in App */}
          <button className="booking-option-btn btn-app" onClick={onOpenApp}>
            <Icon path={mdiCellphone} size={1.5} className="booking-option-icon" />
            <div className="booking-option-text">
              <div className="booking-option-main">{appLabel}</div>
              <div className="booking-option-sub">{appSub}</div>
            </div>
          </button>

          {/* Option 2: Continue on Web */}
          <button className="booking-option-btn btn-web" onClick={onContinueWeb}>
            <Icon path={mdiWeb} size={1.5} className="booking-option-icon" />
            <div className="booking-option-text">
              <div className="booking-option-main">{webLabel}</div>
              <div className="booking-option-sub">{webSub}</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingOptionModal;
